
import Vue from 'vue'
import * as Api from '@/api/PartyIdentityUserApi'
import {IdName} from '@ViewModels/IdName'
import {PartyIdentityUserDto} from '@ViewModels/PartyIdentityUserDto'
import {RoleChangeDto} from '@ViewModels/RoleChangeDto'
import {Alert} from '@/components'
import {SaveButton} from '@/components/buttons'
import {MultiSelect, Passwordbox} from '@/components/formGroups'

export default Vue.extend({
  name: 'ChangeRole',
  props: {schoolId: String, editingItem: Object as () => PartyIdentityUserDto},
  data() {
    return {
      adminAccessKey: '',
      processing: false,
      processed: false,
    }
  },
  computed: {
    roleOptions(): NameValuePair[] {
      return this.$store.getters.roleOptions
          .filter((r: IdName) => r.Name !== 'SchoolAdmin')
          .map((opt: IdName) => ({
            name: opt.Name,
            value: opt.Id.toUpperCase(),
          }))
    },
    roleNames(): string[] {
      if (!this.editingItem) {
        return []
      }
      return this.editingItem.RoleIds.map(roleId => {
        const role = this.roleOptions.find(
            (opt: NameValuePair) => opt.value === roleId.toUpperCase()
        )
        return role ? role.name : ''
      }).filter(r => !!r)
    },
    roleChangeData(): RoleChangeDto {
      const rolesToAdd = this.roleNames.filter(roleName => {
        return !this.editingItem.OriginalRoleNames.find(r => r === roleName)
      })
      const rolesToRemove = this.editingItem.OriginalRoleNames.filter(roleName => {
        return !this.roleNames.find(r => r === roleName)
      })
      return {
        AdminAccessKey: this.adminAccessKey,
        RolesToAdd: rolesToAdd,
        RolesToRemove: rolesToRemove,
      }
    },
    adminAccessKeyRequired(): boolean {
      return this.roleNames.includes('Admin')
    },
    isGrantingAdmin(): boolean {
      const rolesToAdd = this.roleNames.filter(roleName => {
        return !this.editingItem.OriginalRoleNames.find(r => r === roleName)
      })
      return rolesToAdd.includes('Admin')
    },
  },
  mounted() {
    if (this.editingItem.OriginalRoleNames.length === 0) {
      this.editingItem.OriginalRoleNames = this.roleNames
    }
  },
  methods: {
    async action() {
      this.processing = true
      try {
        await Api.changeUserRoles(this.editingItem.Id, this.roleChangeData)
        this.editingItem.OriginalRoleNames = this.roleNames
        this.processing = false
        this.processed = true
      } catch {
        this.processing = false
      }
    },
  },
  components: {
    Alert,
    SaveButton,
    MultiSelect,
    Passwordbox,
  },
})
